import React from "react";

export default function ColorFrame25({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <g clipPath="url(#clip0_2256_162118)">
          <circle cx="55.673" cy="168.882" r="55.673" fill="#BDD0FB"></circle>
          <ellipse
            cx="101.417"
            cy="100.938"
            fill="#BDD0FB"
            rx="62.529"
            ry="54.938"
          ></ellipse>
          <ellipse
            cx="176.544"
            cy="102.892"
            fill="#BDD0FB"
            rx="40.12"
            ry="40.842"
          ></ellipse>
          <path
            fill="#BDD0FB"
            d="M275.858 159.353c2.508 44.44-28.407 70.034-75.663 70.034-18.867 0-60.892.828-96.918 0-44.822-1.03-82.717-5.233-82.717-23.906 0-33.683 137.294-98.291 179.635-98.291 42.342 0 73.694 17.263 75.663 52.163z"
          ></path>
          <path
            fill="#BDD0FB"
            d="M196.806 165.833c-15.62-8.992-18.944-32.501-7.425-52.509 11.518-20.008 34.745-25.157 50.365-16.165 15.619 8.992 17.716 28.721 6.197 48.729-5.675 26.039-33.518 28.937-49.137 19.945z"
          ></path>
          <rect
            width="107.569"
            height="107.569"
            x="83.188"
            y="94.988"
            fill="#fff"
            stroke="#7A6FF7"
            strokeWidth="5.783"
            rx="8.825"
          ></rect>
        </g>
        <defs>
          <clipPath id="clip0_2256_162118">
            <path fill="#fff" d="M0 0H276V276H0z"></path>
          </clipPath>
        </defs>
        {children}
      </g>
    </svg>
  );
}
